<template>
  <div v-if="allowedToShow"
       class="project-progress-table-cell">
    <span :class="{ready: displayProgress === 100}"
          class="percent">{{ displayProgress }}%</span>
    <project-spinner-progress v-if='displayProgress != 100' :progress='displayProgress' :color="progressColor"/>
    <circle-progress
      v-else
      :progress='displayProgress'
      :color="progressColor"
    />
  </div>
</template>

<script>

import { projectStatuses } from '@/constants/projects';
import ProjectSpinnerProgress from '@/components/common/ProjectSpinnerProgress.vue';
import CircleProgress from '@/components/common/CircleProgress.vue';

export default {
  name: 'ProjectProgressTableCell',
  components: {
    CircleProgress,
    ProjectSpinnerProgress,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      options: {
        color: '#007AFF',
        strokeWidth: 0.5,
      },
    };
  },
  computed: {
    allowedToShow() {
      return [projectStatuses.IN_PROGRESS, projectStatuses.FINISHED, projectStatuses.REPEAT_IN_PROGRESS].includes(this.item.status);
    },
    // A finished scan is always 100% complete. The polled progress value can lag
    // behind the terminal status (a late poll may report a partial number), so
    // keep the displayed percentage aligned with the status to avoid showing a
    // finished scan stuck below 100%.
    displayProgress() {
      return this.item.status === projectStatuses.FINISHED ? 100 : this.item.progress;
    },
    progressColor() {
      return this.displayProgress === 100 ? '#2459D5' : '#56C228';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.project-progress-table-cell {
  display: block;
  color: var(--text-primary);
  font-size: $font-size-base;
  margin-right: rem(30);

  .percent {
    display: inline-block;
    color: #56C228;
  }

  .ready {
    color: #2459D5;
  }

  .project-spinner-progress {
    display: inline-block;
    left: rem(9);
    top: rem(10);
    width: rem(24);
    height: rem(24);
  }

  .circle-progress {
    display: inline-block;
    left: $space-1;
    width: rem(24);
    height: rem(24);
  }
}
</style>
